export const introText = {
    title: 'When inspiration calls, originality answers',
    content: '<p>Here, it begins with a single idea. As it travels from one creative mind to the next, it’s reinspired into something&nbsp;new.</p>' +
        '<p>The mediums change, but the message always stays the same: together, we are <span>Original&nbsp;by&nbsp;design</span>.</p>' +
        '<p>Explore the timeline and experience the journey&nbsp;yourself.</p>'
};

export const chapters = [
    {
        key: 'brooke',
        intro: {
            kicker: 'Chapter 1',
            title: 'Brooke Shaden',
            background: 'https://msobd-storage.azureedge.net/images/telephone/brooke-intro.jpg'
        },
        comeBack: 'More from Brooke tomorrow',
        wideBg: 'https://msobd-storage.azureedge.net/images/telephone/brookeWideBg.jpg',
        slides: [
            {
                snap:{
                    kicker: 'Brooke Shaden',
                    title: 'Video Diary 1',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/brooke_1.mp4',
                    cc:'video/telephone/Brooke1.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/brooke-portrait1.jpg'
                }
            },
            {
                text: '"Search, discover, create, release"'
            },
            {
                snap:{
                    kicker: 'Brooke Shaden',
                    title: 'Video Diary 2',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/brooke_2.mp4',
                    cc:'video/telephone/Brooke2.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/brooke-portrait2.jpg'
                }
            },
            {
                text: '"We’ll see if we get this right. The focus is going to be a little tricky"'
            },
            {
                snap:{
                    kicker: 'Brooke Shaden',
                    title: 'Video Diary 3',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/brooke_3.mp4',
                    cc:'video/telephone/Brooke3.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/brooke-portrait3.jpg'
                }
            },
            {
                text: '"Being able to edit on the Surface is completely immersive"'
            }
        ],

        final: {
            kicker: 'Brooke Shaden',
            title: 'Final Piece',
            thumb: 'https://msobd-storage.azureedge.net/images/telephone/brooke-final-thumb.png',
            image: 'https://msobd-storage.azureedge.net/images/telephone/brooke-final.png'
        }
    },
    {
        key: 'marty',
        intro: {
            kicker: 'Chapter 2',
            title: 'Martellus Bennett',
            background: 'https://msobd-storage.azureedge.net/images/telephone/martellus-intro.jpg',
            // soon: 'Coming Monday',
            // soonBackground: 'https://msobd-storage.azureedge.net/images/telephone/martellus-intro-grey.jpg'
        },
        comeBack: 'More from Martellus tomorrow',
        wideBg: 'https://msobd-storage.azureedge.net/images/telephone/martellusWideBg.jpg',
        slides: [
            {
                snap:{
                    kicker: 'Martellus Bennett',
                    title: 'Video Diary 1',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/marty_1.mp4',
                    cc:'video/telephone/Marty1.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/marty-portrait1.jpg'
                }
            },
            {
                text: '"When creativity calls, I always pick up the line"'
            },
            {
                snap:{
                    kicker: 'Martellus Bennett',
                    title: 'Video Diary 2',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/marty_2.mp4',
                    cc:'video/telephone/Marty2.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/marty-portrait2.jpg'
                }
            },
            {
                text: '"I’m going to brighten up the colors…I love colorful worlds"'
            },
            {
                snap:{
                    kicker: 'Martellus Bennett',
                    title: 'Video Diary 3',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/marty_3.mp4',
                    cc:'video/telephone/Marty3.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/marty-portrait3.jpg'
                }
            },
            {
                text: '"I really like the red and the open field... it reminds me of flowers"'
            }
        ],
        final: {
            kicker: 'Martellus Bennett',
            title: 'Final Piece',
            thumb: 'https://msobd-storage.azureedge.net/images/telephone/martellus-final.jpg',
            image: 'https://msobd-storage.azureedge.net/images/telephone/martellus-final.jpg'
        }
    },
    {
        key: 'surfaces',
        intro: {
            kicker: 'Chapter 3',
            title: 'Surfaces',
            background: 'https://msobd-storage.azureedge.net/images/telephone/surfaces-intro.jpg',
            // soon: 'Coming soon',
            // soonBackground: 'https://msobd-storage.azureedge.net/images/telephone/surfaces-intro-grey.jpg'
        },
        comeBack: 'More from Surfaces tomorrow',
        wideBg: 'https://msobd-storage.azureedge.net/images/telephone/surfacesWideBg.jpg',
        slides: [
            {
                snap:{
                    kicker: 'Surfaces',
                    title: 'Video Diary',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/surfaces_1.mp4',
                    cc:'video/telephone/Surfaces.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/Surfaces_2.jpg',
                }
            },

            {
                text: '"It’s playful, it’s helpful, and encouraging... there’s definitely a dreamy aspect to it."'
            },
        ],
        final: {
            kicker: 'Surfaces',
            title: 'Final Piece',
            thumb: 'https://msobd-storage.azureedge.net/images/telephone/surfaces_final.jpg',
            video: 'https://msobd-storage.azureedge.net/videos/telephone/surfaces_final.mp4'
        }
    },
    {
        key: 'cache',
        intro: {
            kicker: 'Chapter 4',
            title: 'Cache Bunny',
            background: 'https://msobd-storage.azureedge.net/images/telephone/cache-intro.jpg',
            // soon: 'Coming soon',
            // soonBackground: 'https://msobd-storage.azureedge.net/images/telephone/cache-intro-grey.jpg'
        },
        comeBack: 'More from Cache tomorrow',
        wideBg: 'https://msobd-storage.azureedge.net/images/telephone/cacheWideBg.jpg',
        slides: [
            {
                snap:{
                    kicker: 'Cache Bunny',
                    title: 'Video Diary 1',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/cache_1.mp4',
                    cc:'video/telephone/Cache.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/cache-portrait1.jpg'
                }
            },
            {
                text: '"These pieces have very different tones... I’m going to use those as story elements"'
            },
            {
                snap:{
                    kicker: 'Cache Bunny',
                    title: 'Video Diary 2',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/cache_2.mp4',
                    cc:'video/telephone/Cache.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/cache-portrait2.jpg'
                }
            },
            {
                text: '"Brooke Shaden’s photos are really beautiful and they have her wearing all red... I’m gonna do my own take on that"'
            },
            {
                snap:{
                    kicker: 'Cache Bunny',
                    title: 'Video Diary 3',
                    video: 'https://msobd-storage.azureedge.net/videos/telephone/cache_3.mp4',
                    cc:'video/telephone/Cache3.vtt',
                    poster: 'https://msobd-storage.azureedge.net/images/telephone/cache-portrait3.jpg'
                }
            },
            {
                text: '"It’s time to start editing... this is gonna be very different from anything I’ve made before"'
            }
        ],
        final: {
            kicker: 'Cache Bunny',
            title: 'Final Piece',
            thumb: 'https://msobd-storage.azureedge.net/images/telephone/cache-final.jpg',
            video: 'https://msobd-storage.azureedge.net/videos/telephone/cache_final.mp4'
        }
    }
];


